import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { TOGGLE_REGION } from "../apiRoutes";

const mutateToggleUpdateGeoRegion = async ({ id }: { id: string | number }) => {
  return await axiosAuth.patch(`${TOGGLE_REGION}${id}`);
};

const useToogleUpdateGeoRegionsMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
			id: string | number;
		},
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateToggleUpdateGeoRegion,
    ...queryParams,
  });

export default useToogleUpdateGeoRegionsMutation;
